import { parsedToken } from "../storageHelper";
import { apiService } from "../apiService";
import urlConfig from "../../../config/domain";

let pToken: any = parsedToken(),
	userID = pToken ? pToken.username : null;

//Show position for a client in equity
export const AEqPosition = (callback: CallableFunction) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.position.eq + userID,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};

//Show position for a client in equity
export const ACommPosition = (callback: CallableFunction) => {
	if (pToken && pToken.accType !== "EQ") {
		apiService(
			{
				url: urlConfig.position.commodity + userID,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};